//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const uia = angular.module('uia');
  const CLIENT_CATALOG_MISSING_TITLE = 'Product feed not found.';
  const CLIENT_CATALOG_MISSING_MSG = 'Contact your Success Manager to enable a feed or enter a product URL instead.';

  uia.directive('showroomProductFilterTypeahead', [
    'ErrorNotificationService',
    'TrackingService',
    'UniversalImageActionsApiService',
    function(
            ErrorNotificationService,
            TrackingService,
            UniversalImageActionsApiService,
        ) {
      return {
        restrict: 'E',
        scope: {
          selectItemCallback: '&',
          trackingCategory: '<',
        },
        require: '^universalImageActionsModal',
        template: require('@legacy-components/common/universal-image-actions/showroom-product-filter-typeahead.html'),
        controller: ['$scope',
          function($scope) {
            const ERR_MISSING_CATALOG_CODE = 2;
            let productSearchRequest;

            $scope.model = {};

            function setTypeaheadEmptyMessage(title, msg) {
              $scope.model.productSearchTypeahead.context.emptyMessageTitle = title;
              $scope.model.productSearchTypeahead.context.emptyMessage = msg;
            }

            $scope.model.productSearchTypeahead = {
              currentQuery() {
                return $scope.model.searchText;
              },
              events: {
                enterKeyed($event, product) {
                  $scope.model.productSearchTypeahead.context.onSelect($event, product);
                },
              },
              context: {
                onSelect($event, product) {
                  if (product) {
                                        // The twitter typeahead directive doesn't use watchers on ngModel, so manually clear the query after adding a product
                    $scope.$broadcast('twitter-typeahead:reset');

                    $scope.selectItemCallback({
                      product,
                    });
                  }
                },
                emptyMessageTitle: "Nuttin' to see here.",
                acornBrokenImage: require('@images/acorn-broken.svg'),
              },
              templates: {
                suggestion: {
                  html: require('@partials/showroom-product-filter-typeahead-suggestion.html'),
                },
                empty: {
                  html: `<placeholder-block image="${require('@images/acorn-search.svg')}"` +
                                                             'image-height="80px"' +
                                                             'title="{{ context.emptyMessageTitle }}"' +
                                                             'subtitle="{{ context.emptyMessage }}"' +
                                                             'no-border="true"' +
                                                             'box-padding="12px"' +
                                                             'box-margin="42px">' +
                                          '</placeholder-block>',
                },
              },
              searchProducts: _.debounce((query, defer) => {
                const params = {
                  search: query,
                };

                $scope.model.outstandingAsyncAction = 'search';

                if (productSearchRequest) {
                                    // Abort is ignored if request already resolved.
                  productSearchRequest.abort();
                }

                                    // Important to stash this particular promise because it has the .abort() method
                productSearchRequest = UniversalImageActionsApiService.searchProductsAsync(params);
                productSearchRequest.then((data) => {
                                    // ignore completion when it's an abort
                  if (!data) {
                    return;
                  }

                  defer.resolve(data);
                  $scope.model.outstandingAsyncAction = null;
                  if (data.length === 0 || (data.length > 0 && (!data[0].name || data[0].images.length === 0))) {
                    TrackingService.recordEvent($scope.trackingCategory, TrackingService.ACTION_SEARCH, 'empty');
                  } else if (data.length > 0) {
                    TrackingService.recordEvent($scope.trackingCategory, TrackingService.ACTION_SEARCH, data[0].searchSource);
                  }
                }).catch((error) => {
                  if (typeof error === 'object') {
                    if (error && error.errorCode === ERR_MISSING_CATALOG_CODE) {
                                            // Show empty result with messaging indicating that the client has no catalog configured
                      setTypeaheadEmptyMessage(CLIENT_CATALOG_MISSING_TITLE, CLIENT_CATALOG_MISSING_MSG);
                      defer.resolve([]);
                      TrackingService.recordEvent($scope.trackingCategory, TrackingService.ACTION_SEARCH_ERROR, 'invalid-query');
                    } else {
                      defer.reject(error);
                      ErrorNotificationService.showDefaultErrorDialog(
                                                'An error occurred while searching. Please try again.', error.errorId,
                                            );
                      TrackingService.recordEvent(
                                                $scope.trackingCategory,
                                                TrackingService.ACTION_SEARCH_ERROR,
                                                error.message,
                                            );
                    }
                  } else {
                    defer.reject(error);
                    ErrorNotificationService.showDefaultErrorDialog('An error occurred while searching. Please try again.');
                    TrackingService.recordEvent($scope.trackingCategory, TrackingService.ACTION_SEARCH_ERROR, error);
                  }
                  $scope.model.outstandingAsyncAction = null;
                });
              }, 400),
            };
          },
        ],
      };
    },
  ]);
})();
